import moment from 'moment';
import React from 'react';
import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';
import CustomPhoneNoView from '../../../../../shared/custom-PhoneNoView/CustomPhoneNoView';
import LocationViewTab from '../../../../../shared/location-view-tab/Location-View-Tab';
import RedirectUrlLink from '../../../../../shared/redirect-url-link/Redirect-Url-Link';
import { decodeMediaKeyValue } from '../../../../../utils/mediaUtils';

const CityGuideDetailView = ({ tabValue, cityGuide }) => {
  const setInfoView = (info) => {
    if (info.email) return info.email;
    if (info.phone) return <CustomPhoneNoView value={info.phone} />;
    if (info.URL) return <RedirectUrlLink url={info.URL} />;
  };

  const setUnits = (units) => {
    return !units ? '---' : units === 'Kilometers' ? 'KMS' : units;
  };

  return (
    <div className='row mx-4 mt-4 city-guide-view'>
      {tabValue === 0 && (
        <>
          <div className='row mt-4'>
            <div className='col-md-4'>
              <div className='details-label'>Activity Name</div>
              <div className='details-value preview-breaks'>{cityGuide.name}</div>
            </div>
            <div className='col-md-4'>
              <div className='details-label'>Status</div>
              <div className='details-value'>
                <div
                  className={`${
                    cityGuide.isActive ? 'pill-active' : 'pill-inactive'
                  } col-md-1 pill-text pill mt-2`}
                >
                  {cityGuide.isActive ? 'Active' : 'Inactive'}
                </div>
              </div>
            </div>
          </div>
          <div className='row mt-4'>
            <div className='col-md-4'>
              <div className='details-label'>Category Name</div>
              <div className='details-value'>{cityGuide.categoryName}</div>
            </div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Activity Code</div>
            <div className='details-value'>{cityGuide.code || '---'}</div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Description</div>
            <div className='details-value preview-breaks'>{cityGuide.description}</div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Distance from Hotel</div>
            <div className='details-value'>
              {cityGuide.distanceFromHotel} {setUnits(cityGuide.units)}
            </div>
          </div>
          <div className='row mt-4'>
            {cityGuide.customAttributes &&
              cityGuide.customAttributes.length > 0 &&
              cityGuide.customAttributes.map((item, index) => (
                <div key={index} className='col-md-6 mb-2'>
                  <div className='details-label'>{item.key}</div>
                  <div className='details-value'>{item.value}</div>
                </div>
              ))}
          </div>
        </>
      )}
      {tabValue === 1 && (
        <div className='col-md-6 mt-4'>
          <div className='details-label'>Available On</div>
          <div className='details-value'>
            {cityGuide.duration?.duration === 'scheduled' ? (
              <>
                <p className='duration-date-time'>
                  From{' '}
                  {moment(cityGuide.duration?.validFromDate, 'DD-MM-YYYY').format('DD MMM, YYYY')}{' '}
                  {moment(cityGuide.duration?.validFromTime, 'HH:mm').format('hh:mm A')}
                </p>
                <p className='duration-date-time'>
                  To {moment(cityGuide.duration?.tillFromDate, 'DD-MM-YYYY').format('DD MMM, YYYY')}{' '}
                  {moment(cityGuide.duration?.tillFromTime, 'HH:mm').format('hh:mm A')}
                </p>
              </>
            ) : (
              <p>All Time</p>
            )}
          </div>
        </div>
      )}
      {tabValue === 2 && <LocationViewTab location={cityGuide.location} />}
      {tabValue === 3 && (
        <>
          {cityGuide.information && cityGuide.information.length > 0 ? (
            <div className='row mt-4 mb-2'>
              <div className='col-md-8'>
                {cityGuide.information.map((information, ndx) => (
                  <div key={ndx}>
                    <div className='details-label'>
                      {information.title} - {information.displayTitle}
                    </div>
                    <div className='details-value'>
                      <p>{setInfoView(information)}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <p className='details-value'>No Data Available</p>
          )}
        </>
      )}
      {tabValue === 4 && (
        <div className='row pt-4'>
          <MediaViewer
            images={cityGuide?.images || []}
            videos={(() => {
              const { Video: videoMediaContent } = decodeMediaKeyValue(cityGuide?.mediaContent);
              return videoMediaContent || cityGuide?.videos || {};
            })()}
            gifs={(() => {
              const { GIF: gifMediaContent } = decodeMediaKeyValue(cityGuide?.mediaContent);
              return gifMediaContent || cityGuide?.gifs || {};
            })()}
          />
        </div>
      )}
    </div>
  );
};

export default CityGuideDetailView;
